import { render, staticRenderFns } from "./instructions.vue?vue&type=template&id=cd4aa0dc&scoped=true"
import script from "./instructions.vue?vue&type=script&lang=js"
export * from "./instructions.vue?vue&type=script&lang=js"
import style0 from "./instructions.vue?vue&type=style&index=0&id=cd4aa0dc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd4aa0dc",
  null
  
)

export default component.exports